import { render, staticRenderFns } from "./TempMailView.vue?vue&type=template&id=08d62ab9&scoped=true"
import script from "./TempMailView.vue?vue&type=script&lang=js"
export * from "./TempMailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d62ab9",
  null
  
)

export default component.exports